import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { object, string, array } from 'yup';

import { sentenceCase } from '../../../utils/utils';

export const emailSchema = (emails) =>
  object({
    // project members and email cannot both be blank. One of them must be filled in
    projectMembers: array()
      .nullable()
      .test(
        'recipient check',
        t('notificationRecipient', { ns: 'validations' }),
        (value) => !isEmpty(value) || !isEmpty(emails)
      ),
    email: string().when('projectMembers', {
      is: (value) => {
        return (isEmpty(value) || value === null) && isEmpty(emails);
      },
      then: (schema) =>
        schema.required(t('notificationRecipient', { ns: 'validations' })),
      otherwise: (schema) => schema,
    }),
    subject: string().required(
      sentenceCase(
        t('inputRequired', {
          ns: 'validations',
          field: t('monitor.emailSubject', { ns: 'fields' }),
        })
      )
    ),
    body: string(),
  });

export const webhookSchema = () =>
  object({
    url: string().required(
      sentenceCase(
        t('inputRequired', {
          ns: 'validations',
          field: t('monitor.webhookUrl', { ns: 'fields' }),
        })
      )
    ),
    text: string().required(
      sentenceCase(
        t('inputRequired', {
          ns: 'validations',
          field: t('monitor.webhookMessage', { ns: 'fields' }),
        })
      )
    ),
  });
